export default "__VITE_ASSET__8h3sOwph__"